/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Other_S1Inputs */

const en_fc_dl_other_s1 = /** @type {(inputs: Fc_Dl_Other_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The web build is the full editor compiled to WebAssembly. Unzip it and serve the folder from any static host.`)
};

/**
* | output |
* | --- |
* | "The web build is the full editor compiled to WebAssembly. Unzip it and serve the folder from any static host." |
*
* @param {Fc_Dl_Other_S1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_other_s1 = /** @type {((inputs?: Fc_Dl_Other_S1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Other_S1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_other_s1(inputs)
});
export { fc_dl_other_s1 as "fc.dl.other.s1" }